module.exports = __webpack_public_path__ + "img/carela-logo.30cbe85f.png";